<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<!--table head-->
			<v-divider class="mt-4" color="black" />
			<v-row class="subtitle-2 mx-4" no-gutters>
				<v-col class="text-left">{{'Available channels' | localize }}</v-col>
				<v-col v-for="item in headers" class="text-center text-pre-wrap" :key="item">
					{{`${item}` | localize }}
				</v-col>
				<v-col class="text-right">{{'Actions' | localize }}</v-col>
			</v-row>
			<v-divider class="mt-2" color="black" />
			<!--to do if-->
			<!--self channels list-->
				<v-expansion-panels focusable v-model="panel">
					<v-expansion-panel>
						<v-expansion-panel-header class="subtitle-2 secondary--text">
							{{'Self-operated & franchise retail channels' | localize }}
						</v-expansion-panel-header>
						<v-expansion-panel-content class="body-2">
							<!--on-line stores-->
							<div v-if="onlineStores?.length > 0">
								<div class="secondary--text my-4 text-left">{{'Online' | localize }} {{'company-owned stores' | localize }}</div>
								<div v-for="channel in onlineStores" :key="channel.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ channel.name }}</v-col>
										<v-col class="text-center">{{ channelTrademarks(channel) }}</v-col>
										<v-col class="text-center">{{ channel.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.peak_market_coverage)}}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.investment_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.sales_last) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.operational_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.franchise_cost) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.franchise_fee) }}</v-col>
										<v-col>
											<change-channel :channel="channel" />
											<delete-channel :channel="channel" />
										</v-col>
									</v-row>
									<v-divider />
								</div>
							</div>

							<!--self - brick&mortar store-->
							<div v-if="outlets?.length">
								<div class="secondary--text my-4 text-left">
									{{'Brick&mortar' | localize }} {{'company-owned stores' | localize }}
								</div>
								<div v-for="channel in outlets" :key="channel.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ channel.name }}</v-col>
										<v-col class="text-center">{{ channelTrademarks(channel) }}</v-col>
										<v-col class="text-center">{{ channel.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.peak_market_coverage) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.investment_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.sales_last) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.operational_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.franchise_cost) }}</v-col>
										<v-col class="text-center">{{ formatNumber(channel.franchise_fee) }}</v-col>
										<v-col>
											<change-channel :channel="channel" />
											<delete-channel :channel="channel" />
										</v-col>
									</v-row>
									<v-divider />
								</div>
							</div>

							<!--franchise stores-->
							<div v-if="franchises?.length">
								<div class="secondary--text my-4 text-left">
									{{'Franchise stores' | localize }}
								</div>
								<div v-for="franchise in franchises" :key="franchise.id">
									<v-row no-gutters>
										<v-col class="text-left">{{ franchise.name }}</v-col>
										<v-col class="text-center">{{ channelTrademarks(franchise) }}</v-col>
										<v-col class="text-center">{{ franchise.stores }}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.peak_market_coverage)
											}}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.investment_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.sales_last) }}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.operational_costs) }}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.franchise_cost) }}</v-col>
										<v-col class="text-center">{{ formatNumber(franchise.franchise_fee) }}</v-col>
										<v-col>
											<change-franchise :channel="franchise" />
											<delete-channel :channel="franchise" />
										</v-col>
									</v-row>
									<v-divider />
								</div>
							</div>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			<v-row class="my-4 mx-8" justify="start">
				<add-channel />
				<sell-franchise :outlets="trademark_stores" />	
			</v-row>

			<!--independent retail-->

			<!--table head-->
			<v-divider color="black"/>
			<v-row class="subtitle-2 mx-6" no-gutters>
				<v-col class="text-left">{{'Chain name' | localize }}</v-col>
				<v-col v-for="item in headers2" class="text-center text-pre-wrap" :key="item">
					{{`${item}` | localize }}
				</v-col>
				<v-col class="text-right">{{'Actions' | localize }}</v-col>
			</v-row>
			<v-divider color="black" />
			<!-- independent chains list -->
			<v-expansion-panels class="mb-12" v-model="panel2" focusable>
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 secondary--text">
						{{'Independent retail chains' | localize }}
					</v-expansion-panel-header>
					<v-expansion-panel-content class="body-2">

						<!--Marketplaces-->
						<div v-if="marketplaces?.length">
							<div class="secondary--text my-4 text-left">
								{{'Online' | localize }} {{'marketplaces' | localize }}
							</div>
							<div v-for="chan in marketplaces" :key="chan.id">
								<v-row no-gutters>
									<v-col class="text-left">{{ chan.name }}</v-col>
									
									<v-col v-if="status(chan) == 'registered'" 
										class="text-center primary--text font-weight-bold">
										{{ `${status(chan)}` | localize }}
									</v-col>
									<v-col v-else
										class="text-center primary--text font-weight-bold">
										{{ status(chan)}}
									</v-col>

									<v-col class="text-center">{{ chan.stores }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage) }}</v-col>
									<v-col class="text-center">{{ formatNumber(lastSales(chan)) }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.entry_fee) }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.annual_fee) }}</v-col>
									<v-col class="text-center">{{ chan.retail_margin * 100}}%</v-col>
									<v-col class="text-center">{{ chan.min_price}}</v-col>
									<v-col class="text-center">{{ chan.max_price }}</v-col>
									<v-col class="text-center">{{ chan.num_trademarks }}</v-col>
									<v-col class="text-center">{{ `${chan.design_main}` | localize }} / {{ `${chan.design_second}` | localize }}</v-col>
									<v-col v-if="status(chan) == 'registered'">
										<!-- suspend from the chain (delete)-->
										<change :chain="chan" :channel="getChannel(chan)" />
										<suspend :channel="getChannel(chan)" />
									</v-col>
									<v-col v-else>
										<register :channel="chan" />
									</v-col>
								</v-row>
								<v-divider />
							</div>
						</div>

						<!--Brick&mortar multibrands chains-->
						<div v-if="bm_chains.length">
							<div class="secondary--text my-4 text-left">
								{{'Brick&mortar' | localize }} {{'multibrands chains' | localize }}
							</div>
							<div v-for="chan in bm_chains" :key="chan.id">
								<v-row no-gutters>
									<v-col class="text-left">{{ chan.name }}</v-col>
									<v-col v-if="status(chan) == 'registered'" 
										class="text-center primary--text font-weight-bold">
										{{ `${status(chan)}` | localize }}
									</v-col>
									<v-col v-else
										class="text-center primary--text font-weight-bold">
										{{ status(chan)}}
									</v-col>

									<v-col class="text-center">{{ chan.stores }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.peak_market_coverage) }}</v-col>
									<v-col class="text-center">{{ lastSales(chan) }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.entry_fee) }}</v-col>
									<v-col class="text-center">{{ formatNumber(chan.annual_fee) }}</v-col>
									<v-col class="text-center">{{ chan.retail_margin * 100 }}%</v-col>
									<v-col class="text-center">{{ chan.min_price }}</v-col>
									<v-col class="text-center">{{ chan.max_price }}</v-col>
									<v-col class="text-center">{{ chan.num_trademarks }}</v-col>
									<v-col class="text-center">{{ `${chan.design_main}` | localize }} / {{ `${chan.design_second}` | localize}}</v-col>
									<v-col v-if="status(chan) == 'registered'">
										<change :chain="chan" :channel="getChannel(chan)" />
										<suspend :channel="getChannel(chan)" />
									</v-col>
									<v-col v-else>
										<register :channel="chan" />
									</v-col>
								</v-row>
								<v-divider />
							</div>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>
	import { localeNumber } from '../../../functions/common';
	import Loader from '../../../layouts/Loader.vue';

	export default {
		data (){
			return {
				icon: 'arrow_right',
				headers: [
					'Trademarks',
					'Stores',
					'Peak market coverage per 1 store',
					'Investment costs',
					'Sales last year (units)',
					'Operational costs',
					'Franchise cost',
					'Franchise fee'
				],
				headers2: [
					'Status',
					'Stores',
					'Peak market coverage per 1 store',
					'Sales last year (units)',
					'Entry fee $',
					'Annual flat fee $',
					'Target retail margin',
					'Min preferable price $',
					'Max preferable price $',
					'Number of trademarks',
					'Main design second design'],
				panel: 0,
				panel2: 0,
				isLoaded: false,
			}
		},		
		computed: {			
			locale() {
				return this.$store.getters.locale;
			},
			game() {
				return this.$store.getters.game;
			},
			team() {
				return this.$store.getters.team;
			},
			chains () {
				return this.$store.getters.chains;
			}, 
			channels () {
				return this.$store.getters.channels;
			},
			trademarks() {
				return this.$store.getters.trademarks;
			},
			intermediary() {
				return this.$store.getters.intermediary;
			},
			// team channels
			onlineStores() {
				let stores = []
				if (this.channels?.length > 0) {
					stores = this.channels.filter(channel => channel.type === 1)
				}
				return stores
			},
			outlets() {
				let stores = []
				if (this.channels?.length > 0) {
					stores = this.channels.filter(channel => (channel.type === 3 || channel.type === 2))
				}
				return stores
			},
			trademark_stores() {
				let stores = []
				if (this.channels?.length > 0) {
					stores = this.channels.filter(channel => (channel.type === 3))
				}
				return stores
			},
			franchises() {
				let stores = []
				if (this.channels?.length > 0) {
					stores = this.channels.filter(channel => channel.type === 4)
				}
				return stores
			},
			marketplaces() {
				let stores = []
				if (this.chains?.length > 0) {
					stores = this.chains.filter(channel => channel.type == 'online')  
				}
				return stores
			},
			bm_chains() {
				let stores = []
				if (this.chains?.length > 0) {
					stores = this.chains.filter(channel => channel.type == 'brick&mortar')
				}
				return stores
			},
		},
		methods: {
			formatNumber(number) {
				if (number) {
					return localeNumber(number, this.locale);
				}
				return 0
			},
			channelTrademarks(channel) {
				const res = channel.trademarks.map(tr => tr.name)
				return res.join(', ');
			},
			status (chain) {
				const inChain = this.channels?.find(ch => (ch.name == chain.name && ch.stores > 0));
				if (inChain) {
					return 'registered';
				}
				return ' - '
			},
			getChannel(chan) {
				const inChain = this.channels?.find(ch => ch.name == chan.name);
				if (inChain) {
					return inChain
				}
				return this.error = 'channel not found!!!!'				
			},
			lastSales(chan)	{
				const inChain = this.channels?.find(ch => ch.name == chan.name);
				if (inChain) {
					return inChain.sales_last;
				}
				return 0;
			}		
			
		},
		components: {
			addChannel: () => import('../../../components/team/channels/addChannel.vue'),
			deleteChannel: () => import('../../../components/team/channels/deleteChannel.vue'),
			changeChannel: () => import('../../../components/team/channels/changeChannel.vue'),
			sellFranchise: () => import('../../../components/team/channels/sellFranchise.vue'),
			changeFranchise: () => import('../../../components/team/channels/changeFranchise.vue'),
			register: () => import('../../../components/team/channels/registerInChain.vue'),
			suspend: () => import('../../../components/team/channels/suspendFromChain.vue'),
			change: () => import('../../../components/team/channels/changeInChain.vue'),
			Loader
		},
		async created() {
			
			if (this.game && this.team) {

				const params = {
					gameId: this.game.id,
					round: this.game.round,
					teamId: this.team.id,
				}

				if (this.channels == null) {
					try {
						await this.$store.dispatch('fetchTeamChannels', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message)
					}
				}

				if (this.chains == null) {
					try {
						await this.$store.dispatch('fetchChains', this.game.id);
					} catch (error) {
						await this.$store.dispatch('setError', error.message)
					}
				}

				if (this.intermediary == null) {
					params.round = params.round > 0 ? params.round - 1 : 0;
					
					try {		
						await this.$store.dispatch('fetchTeamIntermediary', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message)
					}
				}
			}

			if (this.trademarks?.length < 1) {
				try {
					await this.$store.dispatch('fetchTrademarks');
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}

			this.isLoaded = true;
		},
	}
</script>
